export default __webpack_public_path__ + "static/media/BrainBreak cards40.efc152b7.png";